import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function TermsConditionsPage() {
  pageTitle('Terms & Conditions — Ranads');

  return (
    <>
      <Spacing lg='70' md='70' />
      <Spacing lg='140' md='80' />

      <SectionHeadingStyle3
        title='End User License Agreement <br>& Terms of Service'
        subTitle='Terms & Conditions'
        variant='text-center'
        shape='shape_2'
      />

      <Spacing lg='75' md='60' />

      <div className='container'>
        <div className='row'>
          <div className='col-lg-10 offset-lg-1'>
            <Spacing lg='40' md='30' />

            {/* Introduction */}
            <section className='cs_privacy_section'>
              <p className='cs_fs_18 cs_lh_base mb-3'>
                <strong>RANADS S.A.R.L.</strong> ("RANADS," "we," "us," or
                "our") is the developer and sole owner of the digital platform
                and related services available via RANADS websites,
                applications, and APIs (the "Platform"), including all
                intellectual property rights contained therein ("IP"). The
                Platform enables subscribers to deploy and manage digital
                solutions—such as websites, CMS, ERP/CRM modules, automations,
                messaging integrations (including WhatsApp Business API
                integrations), analytics, and marketing utilities—
                (collectively, the "Services").
              </p>
              <p className='cs_fs_18 cs_lh_base mb-3'>
                This End User License Agreement (this "Agreement" or "EULA") is
                a contract between you ("End User," "Subscriber," or "you") and
                RANADS S.A.R.L., Charles Malek Avenue, Achrafiyeh, Beirut,
                Lebanon, governing your access to and use of the Platform and
                the Services.
              </p>
              <p className='cs_fs_18 cs_lh_base mb-3'>
                References to the Platform include: this website and subdomains;
                web and mobile applications; APIs and SDKs; Services; any
                applications, sample and content files, source code, scripts,
                instruction sets or software provided as part of the Services;
                and any related documentation.
              </p>
              <p className='cs_fs_18 cs_lh_base mb-4'>
                <strong>
                  By accessing or using any portion of the Platform or Services,
                  you agree to be bound by this EULA from the date you first do
                  so (the "Effective Date"). If you do not agree to this EULA,
                  you must immediately stop using the Platform and Services.
                </strong>
              </p>
              <p className='cs_fs_18 cs_lh_base mb-0'>
                If this EULA conflicts with a separately executed agreement
                between you and RANADS (e.g., Order Form, Master Services
                Agreement, Statement of Work), that separate agreement controls.
                This EULA applies to the entire Platform, the Services, and any
                email or other communications between you and RANADS concerning
                the Platform. If you violate this EULA, we may suspend or
                terminate your account without notice or liability.
              </p>
            </section>

            <Spacing lg='50' md='40' />

            {/* 1. END USER WARRANTIES */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                1. End User Warranties
              </h2>
              <p className='cs_fs_18 cs_lh_base mb-3'>
                You confirm, warrant, and represent that you:
              </p>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>1.1.</strong> Act on behalf of a legitimate business;
                  are of legal age and capacity to enter into this Agreement;
                  are not located in, organized under the laws of, or ordinarily
                  resident in a country or region subject to comprehensive
                  U.S./EU/UK sanctions; and are not on any restricted party
                  list.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>1.2.</strong> Will use the Platform solely for lawful,
                  legitimate commercial purposes (the "Permitted Purpose"), and
                  not for personal non-business use or prohibited activities,
                  including but not limited to: false advertising; illegal
                  gambling; human trafficking or exploitation; sale of
                  counterfeit or unlawful goods; distribution of illegal drugs;
                  hate speech or incitement to violence; or any conduct
                  violating applicable laws.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>1.3.</strong> Will comply at all times with applicable
                  third-party platform terms and policies for any tools you
                  connect (e.g., Meta/WhatsApp, Google, Apple, Shopify, payment
                  gateways, analytics providers).
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 2. GRANT OF LICENSE */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-3'>
                2. Grant of License
              </h2>
              <p className='cs_fs_18 cs_lh_base mb-0'>
                Subject to your continuing compliance with this EULA (including
                payment of applicable fees), RANADS grants you a limited,
                revocable, non-exclusive, non-transferable license to access and
                use the Platform during your active subscription term (the
                "License"). The License is solely to access the Platform and use
                the Services as described in your order, plan, or SOW. You may
                not sublicense, rent, lease, or transfer the Platform, Services,
                or any portion thereof. All rights not expressly granted are
                reserved by RANADS.
              </p>
            </section>

            <Spacing lg='50' md='40' />

            {/* 3. SUBSCRIPTION */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                3. Subscription
              </h2>
              <p className='cs_fs_18 cs_lh_base mb-4'>
                Unless otherwise agreed in writing:
              </p>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.1. Trial.</strong> We may offer a free or limited
                  trial. Features may be restricted. Trials end automatically
                  unless you purchase a paid Subscription. We may modify or
                  cancel trials at any time.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.2. Plans & Features.</strong> Available plans,
                  features, and limits are as communicated in your
                  Order/Proposal/SOW or on our website. Descriptions are for
                  reference only and do not guarantee particular characteristics
                  beyond what is expressly committed in writing.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.3. Term & Billing.</strong> Paid subscriptions begin
                  upon RANADS's receipt of payment (or the Effective Date stated
                  in the Order) and are billed in advance on a recurring basis
                  (e.g., monthly/annual) per your selected plan.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.4. Ordering.</strong> By submitting an order
                  (including signing a proposal/SOW or completing an online
                  checkout), you agree to pay the stated fees, taxes, and
                  charges.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.5. Fees & Taxes.</strong> Fees are exclusive of all
                  applicable taxes, duties, levies, and withholdings. You are
                  responsible for such amounts and will hold RANADS harmless
                  from them. RANADS may change fees for future terms upon prior
                  notice.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.6. Payment.</strong> Accepted payment methods will
                  be communicated during checkout or in the Order. If payment
                  fails, we may suspend or refuse the order. You bear costs of
                  failed/refused payments.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.7. Auto-Renewal.</strong> Subscriptions renew
                  automatically for successive terms using your current payment
                  method, unless cancelled per your plan's cancellation window.
                  If automatic payment fails, we may invoice you and suspend
                  access until payment is received.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.8. Termination by You.</strong> You may terminate a
                  paid subscription by written notice at any time; however,
                  unless otherwise required by law or the Order, subscriptions
                  are non-cancellable and continue until the current term ends.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.9. Excess Usage / Add-ons.</strong> Usage beyond
                  plan limits or optional add-ons incur additional charges.
                  Continued access may require prepayment of such charges.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.10. Disputed Invoices.</strong> Dispute any invoice
                  portion in good faith within 7 days of invoice date while
                  paying the undisputed portion. Management-level good-faith
                  resolution will be attempted within 15 days. If resolved
                  against you, promptly pay all amounts due.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.11. Late Payment.</strong> We may suspend access
                  and/or charge interest at 1.5% per month (or the maximum
                  allowed by law, if lower) on past due amounts (excluding
                  properly disputed amounts).
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.12. Third-Party Fees.</strong> Our fees exclude
                  charges by third-party platforms you use (e.g., Meta/WhatsApp
                  message fees, payment gateways). You are responsible for such
                  charges.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>3.13. Refunds.</strong> Unless required by law or
                  expressly agreed in writing, all fees are non-refundable.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 4. END USER RIGHTS AND OBLIGATIONS */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                4. End User Rights and Obligations
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.1.</strong> You will not license, sell, resell,
                  transfer, assign, distribute, time-share, or otherwise
                  commercially exploit the Platform for third-party access
                  outside your organization.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.2.</strong> We may provide administrator accounts to
                  you so you can create accounts for your personnel
                  ("Administrative Users").
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.3.</strong> You are responsible for determining
                  suitability, and ensuring your usage stays within the plan
                  limits (including number of permitted users).
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.4.</strong> You are responsible for all use under
                  your credentials, including preventing credential sharing or
                  circumvention of security controls.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.5.</strong> You will maintain reasonable security,
                  including industry-standard malware protection and screening
                  of content you upload or transmit.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-3'>
                  <strong>4.6.</strong> You are responsible for your
                  Administrative Users' acts/omissions. You agree not to:
                </p>
                <ul className='cs_list cs_style_1 cs_fs_18 cs_lh_base'>
                  <li>Activate features beyond your rights of use;</li>
                  <li>
                    Host or transmit content that is illegal or infringes
                    third-party rights;
                  </li>
                  <li>
                    Copy, translate, create derivative works, disassemble,
                    decompile, or reverse engineer any software of the Platform
                    (except to the limited extent permitted by law);
                  </li>
                  <li>
                    Build competitive products or services by copying features
                    or UI or grant competitors access;
                  </li>
                  <li>Disclose source code or underlying ideas/algorithms;</li>
                  <li>Avoid fees or exceed usage limits;</li>
                  <li>Use bots or automated tools to access the Platform.</li>
                </ul>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>4.7.</strong> Notify us immediately of any suspected
                  breach of this EULA or security incident.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 5. CONTENT AND DATA */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                5. Content and Data
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-3'>
                  <strong>5.1. Ownership.</strong> You (and your licensors) own
                  all right, title, and interest in your Media Content and End
                  User Data. For Personal Data within End User Data, you are the
                  data controller and RANADS is the data processor (where
                  applicable under data protection laws).
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  <strong>"Media Content"</strong> means any content you
                  transmit or host via the Platform (e.g., text, images, video,
                  documents).
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  <strong>"End User Data"</strong> means any data, content,
                  materials, or information (including Media Content and
                  Personal Data) you or your Users input to or upload into the
                  Platform.
                </p>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>"Personal Data"</strong> means information relating to
                  an identified or identifiable natural person within End User
                  Data.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.2. Consents.</strong> You will obtain and maintain
                  all necessary Consents required under applicable law before
                  End User Data is submitted to the Platform (e.g., consents
                  from data subjects, recipients, customers).
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.3. License to RANADS.</strong> You grant RANADS a
                  worldwide, non-exclusive, royalty-free license to use, copy,
                  store, transmit, display, and process End User Data solely to
                  provide the Services and as permitted by this EULA.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.4. Representations.</strong> You represent that you
                  have all necessary rights in End User Data and that it does
                  not infringe any third-party rights or violate laws.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.5. Data Processing.</strong> RANADS will process
                  Personal Data in accordance with applicable data protection
                  laws and our Privacy Policy.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.6. Aggregated Data.</strong> Upon termination or
                  upon your request, we will delete End User Data in accordance
                  with our retention/deletion practices, except as required by
                  law. RANADS may generate and use Aggregated Data (data
                  de-identified and not reasonably capable of identifying a
                  person) for analytics, improvements, and benchmarking and may
                  permit subcontractors to process such Aggregated Data under
                  confidentiality.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>5.7. Backups & Security.</strong> You are solely
                  responsible for your own backups and for maintaining
                  appropriate security of your data. RANADS is not liable for
                  loss or corruption of End User Data.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 6. RANADS WARRANTIES; DISCLAIMERS */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                6. RANADS Warranties; Disclaimers
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>6.1. Limited Warranty.</strong> RANADS will use
                  commercially reasonable efforts to provide the Platform in a
                  professional and workmanlike manner consistent with this EULA.
                  THIS IS YOUR SOLE WARRANTY.
                </p>
              </div>

              <div className='cs_terms_item mb-3 cs_warning_box'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>6.2. "AS IS".</strong> THE PLATFORM AND SERVICES ARE
                  PROVIDED "AS IS" AND "AS AVAILABLE." RANADS DISCLAIMS ALL
                  OTHER WARRANTIES (EXPRESS, IMPLIED, STATUTORY), INCLUDING
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                  NON-INFRINGEMENT, AND QUIET ENJOYMENT. WE DO NOT WARRANT
                  UNINTERRUPTED OR ERROR-FREE OPERATION, OR THAT CONTENT WILL BE
                  SECURE OR NOT LOST OR DAMAGED.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>6.3. Third-Party Dependencies.</strong> Your internet
                  access, devices, and third-party platforms (e.g.,
                  Meta/WhatsApp Cloud API, Google, Apple, payment gateways) may
                  affect availability and performance. Changes by such platforms
                  may impact or disrupt the Services. We are not responsible for
                  such changes and may be unable to provide Services in whole or
                  part. Either party may terminate the affected Services if such
                  dependency materially fails.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>6.4. Backups.</strong> While we employ reasonable
                  safeguards, you remain responsible for your own backups and
                  restoration.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 7. BREACH */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                7. Breach
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>7.1. Content Responsibility.</strong> You are
                  responsible for ensuring your use and all End User Data
                  conform to the Permitted Purpose and laws. We do not
                  pre-moderate content but may remove or block content without
                  notice if: (a) we receive a credible infringement complaint;
                  (b) required by authorities; or (c) we reasonably believe
                  content poses risk to you, recipients, the public, or the
                  Platform. You waive claims arising from such removal and will
                  hold us harmless for claims related to your End User Data.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>7.2. Monitoring & Remedies.</strong> We may monitor
                  access/use solely to verify compliance. Material
                  non-compliance may result in suspension or termination at our
                  discretion.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 8. INDEMNITY */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-3'>
                8. Indemnity
              </h2>
              <p className='cs_fs_18 cs_lh_base mb-0'>
                You will defend, indemnify, and hold harmless RANADS from and
                against any claims, losses, liabilities, damages, costs, and
                expenses (including reasonable legal fees) arising out of: (a)
                your unlawful use of the Platform; (b) allegations that End User
                Data infringes, misappropriates, or violates any rights
                (including privacy and IP); or (c) your breach of this EULA.
                This applies to third-party misuse where caused by your
                negligence (e.g., compromised credentials).
              </p>
            </section>

            <Spacing lg='50' md='40' />

            {/* 9. LIMITATION OF LIABILITY */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                9. Limitation of Liability
              </h2>

              <div className='cs_terms_item mb-3 cs_warning_box'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>9.1. Exclusions.</strong> IN NO EVENT WILL RANADS BE
                  LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR
                  CONSEQUENTIAL DAMAGES; LOSS OF PROFITS, REVENUE, DATA,
                  GOODWILL, OR BUSINESS INTERRUPTION; OR DAMAGES OUTSIDE OUR
                  REASONABLE CONTROL, EVEN IF ADVISED OF THE POSSIBILITY.
                </p>
              </div>

              <div className='cs_terms_item cs_warning_box'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>9.2. Cap.</strong> RANADS'S TOTAL AGGREGATE LIABILITY
                  FOR ALL CLAIMS RELATED TO THE PLATFORM OR THIS EULA WILL NOT
                  EXCEED THE FEES PAID BY YOU TO RANADS FOR THE 12-MONTH PERIOD
                  PRECEDING THE EVENT GIVING RISE TO THE CLAIM OR USD 500,
                  WHICHEVER IS LESS.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 10. INTELLECTUAL PROPERTY RIGHTS */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-3'>
                10. Intellectual Property Rights
              </h2>
              <p className='cs_fs_18 cs_lh_base mb-0'>
                RANADS (and its licensors) own all rights, title, and interest
                in the Platform, Services, systems, software, documentation, and
                related materials, including all IP rights. Suggestions or
                feedback you provide may be freely used by RANADS; any resulting
                enhancements become RANADS's exclusive property. RANADS's names,
                logos, and product names are trademarks; no rights are granted
                except as expressly stated. You must not remove proprietary
                notices.
              </p>
            </section>

            <Spacing lg='50' md='40' />

            {/* 11. AI FEATURES */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                11. AI Features
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.1. AI-Generated Content.</strong> Inputs you submit
                  and outputs you receive via AI features are deemed End User
                  Data. You are responsible for such data and will not use AI
                  features to infringe or violate any rights.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.2. Human Review.</strong> You must evaluate and
                  verify AI outputs before relying on them. Seek professional
                  advice where appropriate.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.3. No AI Warranty.</strong> RANADS makes no
                  warranty as to the accuracy, reliability, or completeness of
                  AI outputs. Use at your own risk.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.4. Usage Limits.</strong> Access to AI features may
                  be plan-limited. Exceeding limits may require additional
                  purchases or may result in suspension or throttling. You must
                  not present AI outputs as solely human-generated or use them
                  for decisions with significant effects on individuals (e.g.,
                  employment, credit, housing, legal, or medical decisions).
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.5. Prohibited Activities.</strong> You will not:
                  (i) use AI features to build competing foundational models or
                  SaaS products; (ii) mislead others that outputs are solely
                  human-generated; (iii) violate usage guidelines.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.6. Data Processing & Sharing.</strong> You consent
                  to RANADS processing End User Data (including inputs/metadata)
                  to provide AI outputs, which may involve vetted third-party AI
                  providers under confidentiality.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.7. Evolution.</strong> AI features may change,
                  improve, or be discontinued without prior notice.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>11.8. Acknowledgments.</strong> AI outputs may be
                  inaccurate, biased, or inappropriate; references do not imply
                  endorsement by RANADS.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 12. GOVERNING LAW AND DISPUTE RESOLUTION */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                12. Governing Law and Dispute Resolution
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>12.1. Governing Law.</strong> This EULA is governed by
                  and construed in accordance with the laws of Lebanon, without
                  regard to conflict-of-laws principles.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>12.2. Good-Faith Resolution.</strong> For issues or
                  concerns, contact us (details below). The parties will attempt
                  to resolve disputes amicably within 30 days.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  <strong>12.3. Jurisdiction.</strong> If unresolved, disputes
                  shall be subject to the exclusive jurisdiction of the Courts
                  of Beirut (Lebanon). The language of proceedings shall be
                  Arabic or English.
                </p>
                <p
                  className='cs_fs_18 cs_lh_base text-muted mb-0'
                  style={{ fontStyle: 'italic' }}
                >
                  (If you prefer arbitration instead, we can replace 12.3 with
                  an arbitration clause naming BCDR or another institution.)
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* 13. ADDITIONAL TERMS */}
            <section className='cs_privacy_section'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-4'>
                13. Additional Terms
              </h2>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  <strong>13.1. Communications.</strong> All notices under this
                  EULA must be in writing to:
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  <strong>RANADS S.A.R.L. – Legal Department</strong>
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  Charles Malek Avenue, Achrafiyeh, Beirut, Lebanon
                </p>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  ✉️{' '}
                  <a href='mailto:info@ranads.com' className='cs_text_accent'>
                    info@ranads.com
                  </a>
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.2. Third-Party Beneficiaries.</strong> Where
                  Services are delivered through or with a partner, such partner
                  may enforce relevant EULA terms as an intended third-party
                  beneficiary.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.3. Survival.</strong> Provisions intended to
                  survive termination or expiration (including payment
                  obligations, IP, confidentiality, indemnities, limitations of
                  liability) will survive.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.4. Compliance with Laws & Sanctions.</strong> You
                  will comply with all applicable laws. You must not use the
                  Platform in or for the benefit of sanctioned countries/regions
                  or sanctioned parties.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.5. Variation.</strong> We may update this EULA upon
                  notice to you (e.g., email or posting). Continued use after
                  the effective date constitutes acceptance.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.6. Force Majeure.</strong> Except for payment
                  obligations, neither party is liable for delays or failures
                  due to events beyond reasonable control.
                </p>
              </div>

              <div className='cs_terms_item mb-3'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.7. Severability.</strong> If any term is found
                  unenforceable, it will be modified to the minimum extent
                  necessary to be enforceable, and the remainder will remain in
                  effect.
                </p>
              </div>

              <div className='cs_terms_item'>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  <strong>13.8. Subcontractors.</strong> RANADS may use
                  subcontractors and affiliates in providing the Services and
                  remains responsible for their performance.
                </p>
              </div>
            </section>

            <Spacing lg='50' md='40' />

            {/* Contact */}
            <section className='cs_privacy_section cs_gray_bg_2 cs_rounded_20 p-4 p-lg-5'>
              <h2 className='cs_fs_40 cs_fs_lg_30 cs_semibold mb-3'>Contact</h2>

              <div className='cs_contact_info'>
                <p className='cs_fs_18 cs_medium mb-2'>
                  <strong>RANADS S.A.R.L.</strong>
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  Charles Malek Avenue, Achrafiyeh, Beirut, Lebanon
                </p>
                <p className='cs_fs_18 cs_lh_base mb-2'>
                  📞{' '}
                  <a href='tel:+96170080040' className='cs_text_accent'>
                    +961 70 080 040
                  </a>
                </p>
                <p className='cs_fs_18 cs_lh_base mb-0'>
                  ✉️{' '}
                  <a href='mailto:info@ranads.com' className='cs_text_accent'>
                    info@ranads.com
                  </a>
                </p>
              </div>
            </section>

            <Spacing lg='60' md='50' />
          </div>
        </div>
      </div>

      <Spacing lg='150' md='80' />
    </>
  );
}
